
<dialog #dialogueGenerique>
  <div class="val-boite-dialogue-generique val-flex-conteneur val-flex-colonne">
    <div class="val-boite-dialogue-generique-entete val-flex-conteneur">
      <div class="val-boite-dialogue-generique-entete-libelle val-flex-1">
         <val-simple-libelle [libelle]="titre"></val-simple-libelle>
      </div>
      <div class="val-boite-dialogue-generique-entete-onglet">
        <svg class="" version="1.1" baseProfile="full" viewBox="0 0 36 43" xmlns="http://www.w3.org/2000/svg">
          <path d="M 36 43 V 0 H 0 C 24 10 9 41.5 36 43 Z" shape-rendering="geometricPrecision"></path>
        </svg> 
      </div>
      <div class="val-boite-dialogue-generique-entete-commandes val-flex-conteneur">
          <div class="val-boite-dialogue-generique-entete-commande"
               [ngClass]="{'val-invisible': !validerVisible, 'val-desactive': validerDesactive}"
               (click)="EnvoyerValider()">
            <val-fonte-icone iconeCss="fas fa-check"></val-fonte-icone>
          </div>
        <div class="val-boite-dialogue-generique-entete-commande"
             [ngClass]="{'val-invisible': !annulerVisible, 'val-desactive': annulerDesactive}"
             (click)="EnvoyerAnnuler()">
          <val-fonte-icone iconeCss="fas fa-times"></val-fonte-icone>
        </div>
      </div>
    </div>
    <div class="val-boite-dialogue-generique-bandeau">
      <ng-content select="[bandeau]"></ng-content>
    </div>
    <div class="val-boite-dialogue-generique-contenu val-flex-1">
      <ng-content select="[contenu]"></ng-content>
    </div>
    <div class="val-boite-dialogue-generique-bandeau-bas">
      <ng-content select="[bandeau-bas]"></ng-content>
    </div>
    <div class="val-boite-dialogue-generique-commandes">
      <ng-content select="[commandes]"></ng-content>
    </div>
    <div class="val-boite-dialogue-generique-pied-page">
      <ng-content select="[piedPage]"></ng-content>
    </div>
  </div>
</dialog>
